import { memo } from "react";

import { withT } from "neetocommons/react-utils";
import { Typography } from "neetoui";

const NoResults = withT(({ t }) => (
  <Typography
    className="neeto-ui-text-gray-800 text-md flex h-full items-center justify-center"
    weight="bold"
  >
    {t("neetoMolecules.builderSidebar.noElements")}
  </Typography>
));

export default memo(NoResults);
